<template>
  <div class="min_bg_r" v-route-title="'日志管理'">
    <div class="panel">
      <div class="header-1">
        <h2><a>用户管理 · 日志管理</a></h2>
        <div class="daochu"></div>
      </div>
      <div style="margin-bottom: 20px;">
        <el-table class="yq-table" v-if="userLogs"
                  :data="userLogs.content"
                  style="width: 100%">
          <el-table-column
                  prop="id"
                  label="ID"
                  width="180">
          </el-table-column>
          <el-table-column
                  label="用户名"
                  width="180">
            <span slot-scope="scope">{{scope.row.user.name}}</span>
          </el-table-column>
          <el-table-column
                  prop="createdAt"
                  label="时间">
          </el-table-column>
          <el-table-column
                  prop="content"
                  label="日志内容">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import userLogService from '../service/user-log'

export default {
  name: 'AdminUserLog',
  data(){
    return {
        userLogs: null
    }
  },
  created(){
    this.fetchData()
  },
  methods:{
    async fetchData() {
        const response = await userLogService.listUserLogs({
            page: 0,
            size: 10
        })
        this.userLogs = response.data
    }
  }
}
</script>
